module.exports = __webpack_public_path__ + "ff794343188cb0ee5e8fc6323e11e018.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/content-bg.gif
// module id = 1129
// module chunks = 73